module.exports = __webpack_public_path__ + "static/media/mountadex-iphonex-mountain-about.51da1479.jpg";